import React from "react";

const Req = (props) => {
	const message = props.message != null ? props.message : "*";
	const red = { color: "red" };
	return <b style={red}>{message}</b>;
};

export default Req;
